<mat-form-field
  appearance="outline"
  subscriptSizing="dynamic"
  class="w-full erp-medium-field">

  <mat-select
    [formControl]="control">

    <mat-option
      *ngFor="let o of col.options"
      [value]="o.value">

      {{ o.label }}

    </mat-option>

  </mat-select>

  <mat-error>

    {{ getError() }}

  </mat-error>

</mat-form-field>